// ======================================================================
// File Name       : report
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/report';

export function receiveReportList(apiRes, startPosition) {
  return {
    type: ActionTypes.REPORT_RECEIVE_REPORT_LIST,
    startPosition,
    ...apiRes,
  };
}

export function initDataForDetailEditConfirmDialog(itemSecernId) {
  return {
    type: ActionTypes.REPORT_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG,
    itemSecernId,
  };
}

export function updateReport(payload) {
  return {
    type: ActionTypes.REPORT_UPDATE,
    payload,
  };
}

export function initDataForReportRegisterDialog() {
  return {
    type: ActionTypes.REPORT_INIT_DATA_FOR_REPORT_REGISTER_DIALOG,
  };
}
